import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { SWISS } from '../data/airlinesData';

export default function SwissPage() {
  return <AirlineDetailPage airline={SWISS} />;
}
